module.exports = __webpack_public_path__ + "img/project15_2.jpeg.64e9d6ea.webp";